import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Grid} from 'views/components';
import {CardTable} from 'views/module';

import Card from './Card';

import backend from 'utils/backend';

const List = (props) => {
  const [data, setData] = React.useState([]);
  const [lastEvaluatedKey, setLastEvaluatedKey] = React.useState();
  const [stage, setStage] = React.useState('FILL');
  const requestIdRef = React.useRef(0);

  const progressWrap = props.statusProgressWrap;
  const selection = props.selection;
  const reload = props.reload;

  const isLoading = stage === 'LOADING';

  const loadData = () => {
    const reqId = requestIdRef.current;
    progressWrap(async () => {
      const filter = [];

      for (const filterSelected of Object.values(selection.filter)) {
        const rawValue = filterSelected.optionSelected;
        const value = filterSelected.filterData.type === 'text' && typeof rawValue === 'string' ?
          rawValue.replace(/[^a-z0-9 ]/gi, '') : rawValue;
        filter.push(
            {
              key: filterSelected.filterData.key,
              value: value,
            },
        );
      }

      const sortBy = {
        sortKey: 'createdAt',
        sortDirection: 'DESC',
      };

      const result = await backend.client.queryClient(filter, sortBy, lastEvaluatedKey);
      if (reqId !== requestIdRef.current) return;
      setData((e) => {
        return [
          ...e,
          ...result.list,
        ];
      });
      setLastEvaluatedKey(result.lastEvaluatedKey);
    }, {setStage, showProgress: false});
  };

  React.useEffect(() => {
    requestIdRef.current += 1;
    setData([]);
    setLastEvaluatedKey(null);
    loadData();
  }, [selection, reload]);


  return (
    <Grid container>
      <CardTable
        data={data}
        card={Card}
        isLoading={isLoading}
        loadMore={loadData}
        hasMore={!!lastEvaluatedKey}
      />
    </Grid>
  );
};
List.propTypes = {
  statusProgressWrap: PropTypes.func.isRequired,
  selection: PropTypes.object.isRequired,
  reload: PropTypes.number.isRequired,
};

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, dispatch)(React.memo(List));
